/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    bool, func, node, string,
} from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import dialogCss from './Dialog.module.css';

const Dialog = ({
    isOpen, onClose, children, title,
}) => {
    if (!isOpen) return <></>;
    useStyles(dialogCss);
    useEffect(() => {
        if (isOpen) {
            document.body.setAttribute('style', 'overflow: hidden');
        }
    }, [isOpen]);
    const dialogClose = () => {
        document.body.removeAttribute('style', 'overflow');
        onClose();
    };
    const handleBackdropClick = (event) => {
        if (event.target.classList.contains(dialogCss.dialogOverlay)) {
            dialogClose();
        }
    };
    document.addEventListener('click', handleBackdropClick);
    return (
        <div className={`${dialogCss.dialogOverlay} dialog-container`}>
            <div className={`${dialogCss.dialogContent} dialog-content`}>
                <div className={`${dialogCss.dialogHeader} dialog-header`}>
                    {title && (<h2 className={`${dialogCss.dialogTitle} dialog-title`}>{title}</h2>)}
                    <button type="button" className={`${!title ? dialogCss.dialogCloseButton : dialogCss.dialogCloseButtonWithTitle} dialog-close-button`} onClick={dialogClose}>
                        <svg className="MuiSvgIcon-root AddonModal-closeIcon-1775" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
                    </button>
                </div>
                <div className={`${dialogCss.dialogBody} dialog-body`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

Dialog.propTypes = {
    children: node,
    isOpen: bool,
    onClose: func,
    title: string,
};
Dialog.defaultProps = {
    children: (<></>),
    isOpen: false,
    onClose: () => {},
    title: null,
};

export default Dialog;
